export default __webpack_public_path__ + "static/autoklaw-4f3ed0da1c51255790d5b6577efa10ec.jpg";